import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const ThumbsUpIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 16 16", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} style={{ fontSize: 20 }} {...rest}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    transform="translate(-124.000000, -52.000000)"
                    fill="#33006E"
                    fillRule="nonzero"
                >
                    <g transform="translate(104.000000, 40.000000)">
                        <g transform="translate(20.000000, 12.000000)">
                            <path d="M0,14 L2.90909091,14 L2.90909091,5.6 L0,5.6 L0,14 Z M16,6.3 C16,5.53 15.3454545,4.9 14.5454545,4.9 L9.96363636,4.9 L10.6909091,1.68 C10.6909091,1.61 10.6909091,1.54 10.6909091,1.47 C10.6909091,1.19 10.5454545,0.91 10.4000285,0.7 L9.6,0 L4.8,4.62 C4.50909091,4.83 4.36363636,5.18 4.36363636,5.6 L4.36363636,12.6 C4.36363636,13.37 5.01818182,14 5.81818182,14 L12.3636364,14 C12.9454545,14 13.4545455,13.65 13.6727273,13.16 L15.8545455,8.18997255 C15.9272727,8.04997255 15.9272727,7.83997255 15.9272727,7.69997255 L15.9272727,6.29997255 L16,6.29997255 C16,6.37 16,6.3 16,6.3 Z"></path>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};
